'use client'

import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Axios } from '../Axios/Axios'
import FullScreenSpinner from '../Spinner/FullScreenSpinner'
import { Notification } from '../Notification/Notification'

const axios = new Axios();

export default function Carrer() {
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    message: '',
    CVFile: {
      FormFile: file,
      FileName: fileName
    },
    type: 'career'
  });
  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    cv: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    setErrors(prevState => ({
      ...prevState,
      [name]: ''
    }));
  };

  // useEffect( () => {

    
  //   if ( file ){
  //     setLoading(true);
  //     uploadFile();
  //   }

  // }, [file])
  
  const uploadFile = async () => {
    if (!file) {
      console.error("No file selected");
      return;
    }
  
    const formData = new FormData();
    formData.append("FormFile", file);
    formData.append("FileName", fileName);

    await axios.upload("api/home/upload-cv", formData).then ( (response) => {
      if (response.status === 201) {
          setFormData( prev => ({...prev, CVFilePath: response.data }))
          return true;
      }
    }).catch( (error) => {
      console.error(error);
      return false;
    }).finally( () => { setLoading(false) });
  };

  const saveFile = (e) => {
    const selectedFile = e.target.files[0];
  
    setFile(selectedFile);
    setFileName(selectedFile.name);
  
    setFormData((prev) => ({
      ...prev,
      CVFile: {
        ...prev.CVFile, // Spread the previous CVFile object
        FormFile: selectedFile,
        FileName: selectedFile.name
      }
    }));
  };
  

  useEffect( () => {

    if (notification.message) {
      setTimeout(() => {
        setNotification({ message: '', type: '' });
      }, 5000);
    }

  }, [notification])

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = {};
  
    console.log(formData);

    if (!formData.firstName) formErrors.firstName = "Полето за Име е задолжително.";
    if (!formData.lastName) formErrors.lastName = "Полето за Презиме е задолжително.";
    if (!formData.email) formErrors.email = "Полето за Електронска Пошта е задолжително.";
    if (!formData.phoneNumber) formErrors.phoneNumber = "Полето за телефонски број е задолжително.";
    if (!formData.CVFile.FormFile) formErrors.cv = "Полето за резиме е задолжително.";
    
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setLoading(true);

    // const upload_response = await uploadFile();

    // if (!upload_response) {
    //   setNotification({
    //     message: 'Настана проблем при прикачување на вашето ресиме.',
    //     type: 'error',
    //   });
    // }

    axios.post('api/home/send-mail', formData).then((response) => {
      if (response.status === 200) {
        setNotification({
          message: 'Електронската Поштата е успешно испратена!',
          type: 'success',
        });
      }else{
        setNotification({
          message: 'Електронската Пошта не е успешно испратена. Ве молиме пробајте подоцна.',
          type: 'error',
        });
      }
    })
    .catch((error) => {
      console.error('Error submitting form:', error);
      setNotification({
        message: 'Електронската Пошта не е успешно испратена. Ве молиме пробајте подоцна.',
        type: 'error',
      });
    })
    .finally(() => {
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        message: '',
        CVFilePath: '',
        type: 'career'
      })
      setLoading(false);
    });
  };

  return (
    <>
    <FullScreenSpinner display={loading} />
    <Helmet>
      <title>EES | Кариера</title>
      <meta name="title" content="Кариера | Вашата енергетичка експертиза" />
      <meta name="description" content="Контактирајте не за сите ваши прашања, барања или дополнителни информации. Ние сме тука за вас!" />
      <meta name="keywords" content="контактирајте не, прашања, поддршка, информации, кариера" />
    </Helmet>
    <div className="isolate bg-white px-6 py-10 sm:pb-32 lg:px-8">
    <div
      aria-hidden="true"
      className="absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]"
    >
      <div
        style={{
          clipPath:
            'polygon(62.1% 38.1%, 95% 56.9%, 90.5% 23.9%, 80.5% 1.1%, 75.7% 4%, 65.5% 28.5%, 55.2% 58.4%, 45.4% 64.1%, 47.5% 52.3%, 40.2% 30.5%, 32.5% 70.7%, 5.1% 59.9%, 22.9% 100%, 32.6% 70.8%, 70.1% 92.7%, 64.1% 48.1%)',
        }}
        className="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[45deg] bg-gradient-to-tr from-[#60a5fa] to-[#3b82f6] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
      />
    </div>

      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Придружете се на нашиот тим</h2>
        <br />
        <p className="mt-4 text-lg text-gray-600">
          Дали сте заинтересирани за кариера во нашата компанија? Ве молиме пополнете го формуларот подолу и испратете ни ги деталите за вашата апликација. Ќе се вратиме кај вас што е можно поскоро.
        </p>
      </div>  


      {notification.message && <Notification message={notification.message} type={notification.type} />}

      <form onSubmit={handleSubmit} className="mx-auto mt-10 max-w-xl sm:mt-20">
        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
          <div>
            <label htmlFor="first-name" className="block text-sm/6 font-semibold text-gray-900">
              <span className='text-red-600' >*</span> Име
            </label>
            <div className="mt-2.5">
              <input
                id="first-name"
                name="firstName"
                type="text"
                value={formData.firstName}
                onChange={handleChange}
                autoComplete="given-name"
                required
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
              {errors.firstName && <span className="text-red-600 text-sm">{errors.firstName}</span>}
            </div>
          </div>
          <div>
            <label htmlFor="last-name" className="block text-sm/6 font-semibold text-gray-900">
              <span className='text-red-600' >*</span> Презиме
            </label>
            <div className="mt-2.5">
              <input
                id="last-name"
                name="lastName"
                type="text"
                value={formData.lastName}
                onChange={handleChange}
                autoComplete="family-name"
                required
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
              {errors.lastName && <span className="text-red-600 text-sm">{errors.lastName}</span>}
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="email" className="block text-sm/6 font-semibold text-gray-900">
              <span className='text-red-600' >*</span> Електронската Пошта
            </label>
            <div className="mt-2.5">
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                autoComplete="email"
                required
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
              {errors.email && <span className="text-red-600 text-sm">{errors.email}</span>}
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="phone-number" className="block text-sm/6 font-semibold text-gray-900">
              <span className='text-red-600' >*</span> Телефонски број
            </label>
            <div className="mt-2.5">
              <input
                id="phone-number"
                name="phoneNumber"
                type="text"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="+389 71 123 123"
                required
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
              {errors.phoneNumber && <span className="text-red-600 text-sm">{errors.phoneNumber}</span>}
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="message" className="block text-sm/6 font-semibold text-gray-900">
              Порака
            </label>
            <div className="mt-2.5">
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
            </div>
            <div class="mt-7 flex items-center justify-center w-full">
            {formData.CVFile.FileName === null ? (
                <label
                    htmlFor="dropzone-file"
                    className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                        <svg
                            className="w-8 h-8 mb-4 text-gray-500"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 16"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                            />
                        </svg>
                        <p className="mb-2 text-sm text-gray-500">
                            <span className="font-semibold">Прикачете го вашето ресиме тука</span>
                        </p>
                        <p className="text-xs text-gray-500">PDF, DOC, DOCX (MAX. 100mb)</p>
                    </div>
                    <input
                        id="dropzone-file"
                        type="file"
                        onChange={saveFile}
                        accept=".pdf,.doc,.docx"
                        className="hidden"
                    />
                </label>
            ) : (
                // Show success message or file name after upload
                <div className="flex flex-col items-center justify-center p-4 bg-green-100 border border-green-400 rounded-lg w-full py-8">
                    <svg
                        className="w-8 h-8 mb-4 text-green-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M16 6L9 13l-4-4m0 0l-4-4m4 4l4-4"
                        />
                    </svg>
                    <p className="mb-2 text-sm text-green-600">
                        {`Вашето ресиме успешно е прикачено: ${fileName != null ? fileName.split("\\").pop() : ''}`}
                    </p>
                    <button
                        onClick={() => {
                            setFormData({ ...formData, CVFilePath: '' });
                        }}
                        className="text-xs text-blue-500 hover:underline"
                    >
                        Прикачи пак
                    </button>
                </div>
            )}
            </div> 
              {errors.cv && <span className="text-red-600 text-sm">{errors.cv}</span>}

          </div>
        </div>
        <div className="mt-10">
          <button
            type="submit"
            variant="gradient"
            className="block w-full rounded-md bg-gray-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          >
            Ајде да збориме
          </button>
        </div>
      </form>
    </div>
    </>
  );
}
